import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import './DistributorNextStepsDashboard.scss';
import { isDistributorCertified } from '@reliv/pws-owner-info';
import t from 'rcm-i18n';
import { getCurrentUserId } from '@rcm/current-user';

const DistributorNextStepsDashboard = () => {

    const [isCertified, setIsCertified] = useState(true);
    useEffect(() => {
        isDistributorCertified(getCurrentUserId()).then((isCertifiedValueFromServer) => {
            setIsCertified(isCertifiedValueFromServer);
        });
    }, []);

    if (isCertified) {
        return null;
    }

    return <div className="DistributorNextStepsDashboard">
        <div className="not-yet-certified-alert">
            <p>{t('You are not yet a certified distributor.')}</p>
            <a className="btn btn-primary" href="/distributor-certification-training">{t('Get Certified')}</a>
        </div>
    </div>;
};
export default DistributorNextStepsDashboard;
